import { Component } from '@angular/core';
import { Select } from '@ngxs/store';
import { AuthState } from '../../../shared/store/state/auth.state';
import { Observable } from 'rxjs';
import { ISchool } from '../../../shared/interfaces/groups/school.interface';

@Component({
    selector: 'app-view-school',
    templateUrl: './view-school.component.html',
    styleUrls: ['./view-school.component.scss'],
})
export class ViewSchoolComponent {
    @Select(AuthState.currentSchool) public currentSchool$: Observable<ISchool>;
}
